import { Card } from "@mui/material";
import { CardContent } from "@mui/material";
import { CardMedia } from "@mui/material";
import { Grid } from "@mui/material";
import PropTypes from 'prop-types';
import React from 'react';
import { Typography } from "@mui/material";
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(theme => ({
  media: {
    height: 0
  },
  content: {
    paddingBottom: theme.spacing(2)
  },
  center: {
    textAlign: 'center'
  }
}));

const ImageStatCard = ({ title, image, imageHeight, stats }) => {
  const classes = useStyles();
  return (
    <Card>
      <CardMedia
        title={title}
        image={image}
        className={classes.media}
        style={{ paddingTop: imageHeight }}
      />
      <CardContent className={classes.content}>
        <Grid
          container
          spacing={0}
          alignItems={'center'}
          direction={'row'}
          justifyContent={'space-between'}
        >
          {stats.map((stat, index) => (
            <Grid item xs className={classes.center} key={index}>
              <Typography variant="h6" gutterBottom>
                {stat.value}
              </Typography>
              <Typography variant="caption">{stat.title}</Typography>
            </Grid>
          ))}
        </Grid>
      </CardContent>
    </Card>
  );
};

ImageStatCard.propTypes = {
  title: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  imageHeight: PropTypes.number.isRequired,
  stats: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      value: PropTypes.number
    })
  ).isRequired
};

export default ImageStatCard;
